// extracted by mini-css-extract-plugin
export default {"normalXl2":"styles_normalXl2__XEpuw","normalXl":"styles_normalXl__-eItA","normalLg":"styles_normalLg__bV9Hu","normalMd":"styles_normalMd__4Tpe3","normalSm":"styles_normalSm__l6sNg"};